import {
  GOODS_RECEIPT_STATES,
  MATCH_STATUSES,
  PAYABLES_AGEING_BUCKETS,
  PURCHASE_ORDER_STATES,
  PURCHASE_REQUEST_STATES,
  VENDOR_INVOICE_STATES,
  RETENTION_BASES,
  VENDOR_ADVANCE_STATES,
  BUDGET_DIMENSIONS,
  BUDGET_STATES,
  BUDGET_VERSION_STATES,
  BUDGET_CHECK_STATUSES,
  STOCK_DOCUMENT_KINDS,
  STOCK_DOCUMENT_STATES,
  STOCK_MOVEMENT_KINDS,
  STOCK_COUNT_STATES,
  STOCK_COUNT_SCOPES,
  CUSTODY_COUNTERPARTIES,
  CUSTODY_DIRECTIONS,
  CUSTODY_STATES,
  DELIVERY_SOURCES,
  DELIVERY_STATES,
  DELIVERY_COST_KINDS,
  DELIVERY_COST_TREATMENTS,
  DELIVERY_RETURN_DOCUMENTS,
  PERFORMANCE_STATUSES,
  PROFIT_TRANSITIONS,
  BUDGET_PERIOD_BASES,
  DRIVER_KINDS,
  CASH_ADVANCE_STATES,
  SPEND_STATES,
  RECURRENCES,
  WAREHOUSE_KINDS,
  ITEM_STATES,
  ISSUE_TARGETS,
  CONSTRUCTION_CONTRACT_STATES,
  CONTRACT_KINDS,
  CERTIFICATE_STATES,
  GUARANTEE_KINDS,
  GUARANTEE_STATES,
  MILESTONE_STATES,
  PROGRESS_ENTRY_KINDS,
  ASSET_STATES,
  ASSET_EVENT_KINDS,
  ASSET_CATEGORY_STATES,
  DEPRECIATION_RUN_STATES,
  EMPLOYMENT_STATES,
  LEAVE_REQUEST_STATES,
  PAYROLL_RUN_STATES,
  HANDOVER_CASE_STATES,
  EXPENSE_STATES,
  DATA_RESET_STATES,
  DATA_RESET_SCOPES,
  TEMPLATE_KINDS,
  REVENUE_RECOGNITION_RULES,
  PROJECT_COST_SOURCES,
  TEMPLATE_STATES,
  APPOINTMENT_KINDS,
  APPOINTMENT_STATES,
  DEFECT_STATES,
  DEFECT_RESPONSIBLE,
  TICKET_KINDS,
  TICKET_PRIORITIES,
  TICKET_STATES,
  VENDOR_KINDS,
  VENDOR_QUALIFICATIONS,
  VENDOR_STATES,
  CONTACT_ITEM_STATES,
  PHONE_STATUSES,
  PERFORMANCE_ENTRY_STATES,
  PERFORMANCE_KINDS,
  PERFORMANCE_SOURCES,
  ACCOUNT_STATES,
  COMPANY_COMPLETENESS_ITEMS,
  COMPLETENESS_NEEDS,
  READINESS_AREAS,
  READINESS_CHECKS,
  READINESS_NEEDS,
  READINESS_STATUSES,
  SIGNATORY_DOCUMENTS,
  APPROVAL_OPERATION_TYPES,
  ORG_STATUSES,
  SCOPE_LEVELS,
  DECISION_KINDS,
  INSTRUMENT_ENDORSEMENT_STATUSES,
  REQUEST_STATES,
  HANDOVER_STATES,
  INSTRUMENT_AGEING_BUCKETS,
  MATCH_STATES,
  MOVEMENT_DIRECTIONS,
  MOVEMENT_KINDS,
  MOVEMENT_STATES,
  OUTGOING_CHEQUE_STATES,
  OUTGOING_PAYMENT_METHODS,
  PAYMENT_REQUEST_STATES,
  STATEMENT_LINE_DIRECTIONS,
  STATEMENT_STATES,
  TRANSFER_STATES,
  TREASURY_ACCOUNT_KINDS,
  TREASURY_RECORD_STATES,
  TREASURY_WARNINGS,
  AGEING_BUCKETS,
  CHARGE_KINDS,
  CONTRACT_CHANGE_BLOCKERS,
  CONTRACT_CHANGE_KINDS,
  CONTRACT_CHANGE_STATES,
  CUSTOMER_MERGE_BLOCKERS,
  DISTRIBUTION_METHODS,
  DISTRIBUTION_RULE_STATES,
  DISTRIBUTION_SKIP_REASONS,
  COMMISSION_BENEFICIARIES,
  SALES_COMMISSION_KINDS,
  SALES_COMMISSION_STATES,
  CHARGE_STATES,
  CREDIT_MOVEMENT_KINDS,
  INVOICE_KINDS,
  INVOICE_STATES,
  REFUND_METHODS,
  REFUND_SOURCES,
  REFUND_STATES,
  WAIVER_STATES,
  WAIVER_TARGETS,
  ACCOUNT_CATEGORIES,
  ENTRY_KINDS,
  ENTRY_SIDES,
  ENTRY_STATES,
  FISCAL_YEAR_STATES,
  JOURNALS,
  LEDGER_ACCOUNT_STATES,
  PARTY_KINDS,
  PERIOD_ACTIONS,
  PERIOD_STATES,
  POSTING_EVENT_KEYS,
  FINANCIAL_LINES,
  CASH_FLOW_ACTIVITIES,
  STATEMENT_KINDS,
  PERIOD_PRESETS,
  COMPARISONS,
  GROWTH_BASES,
  STATEMENT_ISSUES,
  RECOGNITION_BASES,
  RECOGNITION_DIRECTIONS,
  RECOGNITION_STATES,
  AWARD_STATES,
  QUOTE_EXCLUSIONS,
  VENDOR_PREREQUISITES,
  VENDOR_INVOICE_KINDS,
  POSTING_EVENT_STATES,
  POSTING_RULE_STATES,
  SUBLEDGER_KINDS,
  UNPOSTED_REASONS,
  ACTIVITY_KINDS,
  DATE_COMPONENTS,
  RESET_POLICIES,
  SEQUENCE_STATES,
  SEQUENCE_TYPES,
  AMENDMENT_STATES,
  CONTRACT_EXCEPTIONS,
  CONTRACT_PARTY_ROLES,
  CONTRACT_WARNINGS,
  QUOTATION_STATES,
  ISSUED_DOCUMENT_TYPES,
  ISSUED_STATES,
  ISSUE_WARNINGS,
  VERIFICATION_RESULTS,
  SIGNING_STATES,
  CONSENT_SOURCES,
  CONTACT_CHANNELS,
  CUSTOMER_KINDS,
  DECISION_ROLES,
  DUPLICATE_MATCHES,
  IDENTITY_TYPES,
  LEAD_AGE_BANDS,
  HOLD_STATES,
  OPPORTUNITY_STAGES,
  PLAN_TEMPLATE_STATES,
  PRICE_VERSION_STATES,
  REFUND_HANDOFF_STATES,
  RESERVATION_EXCEPTIONS,
  UNIT_EVENT_KINDS,
  QUALIFICATION_PURPOSES,
  QUALIFICATION_TIMEFRAMES,
  CAMPAIGN_OBJECTIVES,
  CAMPAIGN_PLATFORMS,
  CAMPAIGN_STATES,
  CONTRACT_STATES,
  FINISHING_STATUSES,
  INSTALLMENT_FREQUENCIES,
  INSTALLMENT_KINDS,
  INSTALLMENT_STATES,
  IMPORT_KINDS,
  IMPORT_ROW_STATUSES,
  IMPORT_STATES,
  INSTRUMENT_KINDS,
  INSTRUMENT_STATES,
  LEAD_SOURCES,
  LEAD_STAGES,
  FOLLOW_UP_STATUSES,
  CONTACT_RESULTS,
  FOLLOW_UP_KINDS,
  LEAD_INTEREST_STATES,
  LEAD_OUTCOME_KINDS,
  LEAD_WORK_CATEGORIES,
  SETTABLE_FOLLOW_UP_STATUSES,
  UNMAPPED_FOLLOW_UP,
  NOTIFICATION_STATES,
  NOTIFICATION_TYPES,
  PAYMENT_METHODS,
  PROJECT_STATUSES,
  PROPERTY_TYPES,
  RECEIPT_STATES,
  REMINDER_CHANNELS,
  REMINDER_STATES,
  RESERVATION_STATES,
  SUPPORTED_LOCALES,
  TASK_PRIORITIES,
  TASK_STATES,
  UNIT_STATUSES,
  USAGE_TYPES,
  type Locale,
  APPROVER_SCOPES,
  CONDITION_FIELDS,
  CONDITION_OPERATORS,
  OPENING_LINK_STATUSES,
  OPENING_LEDGER_TREATMENTS,
  POLICY_STATES,
  RISK_LEVELS,
  SELF_APPROVAL_MODES,
  STAGE_RULES,
  APPROVER_RULE_KINDS,
} from '@alola/contracts';
import type { ResourceTree } from './resources';

/**
 * Every domain enumeration the interface displays, keyed by the `common` namespace object that labels
 * it (I18N-002, I18N-008).
 *
 * A label such as `receiptState.reversed` is looked up with a key built at runtime, so the typed `t`
 * cannot check it and the key-parity check cannot either — parity only compares Arabic with English,
 * and a namespace missing from **both** languages is perfectly symmetrical. That is exactly how the
 * receipt state reached the screen untranslated. This registry closes the gap: each entry is the
 * contract's own value list, so a value added to a contract without a label in both languages fails
 * `npm run check:i18n`.
 *
 * Add a row here in the same change that renders a new enumeration.
 */
export const DISPLAYED_ENUMS: Readonly<Record<string, readonly string[]>> = {
  leadStage: LEAD_STAGES,
  leadInterest: LEAD_INTEREST_STATES,
  followUpStatus: [...FOLLOW_UP_STATUSES, UNMAPPED_FOLLOW_UP],
  contactResult: CONTACT_RESULTS,
  followUpKind: FOLLOW_UP_KINDS,
  followUpHint: SETTABLE_FOLLOW_UP_STATUSES,
  leadWorkCategory: LEAD_WORK_CATEGORIES,
  leadOutcome: LEAD_OUTCOME_KINDS,
  customerRelation: ['customer', 'reserving', 'contractHolder', 'completedBuyer'],
  leadSource: LEAD_SOURCES,
  activityKind: ACTIVITY_KINDS,
  unitStatus: UNIT_STATUSES,
  projectStatus: PROJECT_STATUSES,
  propertyType: PROPERTY_TYPES,
  usageType: USAGE_TYPES,
  finishingStatus: FINISHING_STATUSES,
  reservationState: RESERVATION_STATES,
  contractState: CONTRACT_STATES,
  installmentState: INSTALLMENT_STATES,
  installmentKind: INSTALLMENT_KINDS,
  frequency: INSTALLMENT_FREQUENCIES,
  paymentMethod: PAYMENT_METHODS,
  receiptState: RECEIPT_STATES,
  instrumentKind: INSTRUMENT_KINDS,
  instrumentState: INSTRUMENT_STATES,
  reminderState: REMINDER_STATES,
  reminderChannel: REMINDER_CHANNELS,
  campaignPlatform: CAMPAIGN_PLATFORMS,
  campaignObjective: CAMPAIGN_OBJECTIVES,
  campaignState: CAMPAIGN_STATES,
  performanceKind: PERFORMANCE_KINDS,
  performanceSource: PERFORMANCE_SOURCES,
  performanceEntryState: PERFORMANCE_ENTRY_STATES,
  contactItemState: CONTACT_ITEM_STATES,
  contactPhoneStatus: PHONE_STATUSES,
  vendorKind: VENDOR_KINDS,
  vendorState: VENDOR_STATES,
  vendorQualification: VENDOR_QUALIFICATIONS,
  purchaseRequestState: PURCHASE_REQUEST_STATES,
  purchaseOrderState: PURCHASE_ORDER_STATES,
  vendorInvoiceState: VENDOR_INVOICE_STATES,
  goodsReceiptState: GOODS_RECEIPT_STATES,
  matchStatus: MATCH_STATUSES,
  payablesAgeingBucket: PAYABLES_AGEING_BUCKETS,
  statementRowKind: ['invoice', 'payment', 'cancellation', 'advancePayment'],
  retentionBase: RETENTION_BASES,
  vendorAdvanceState: VENDOR_ADVANCE_STATES,
  budgetDimension: BUDGET_DIMENSIONS,
  budgetState: BUDGET_STATES,
  budgetVersionState: BUDGET_VERSION_STATES,
  budgetLevel: ['normal', 'alert', 'exceeded'],
  budgetCheckStatus: BUDGET_CHECK_STATUSES,
  stockDocumentKind: STOCK_DOCUMENT_KINDS,
  stockDocumentState: STOCK_DOCUMENT_STATES,
  stockMovementKind: STOCK_MOVEMENT_KINDS,
  stockCountState: STOCK_COUNT_STATES,
  warehouseKind: WAREHOUSE_KINDS,
  itemState: ITEM_STATES,
  issueTarget: ISSUE_TARGETS,
  stockCountScope: STOCK_COUNT_SCOPES,
  custodyDirection: CUSTODY_DIRECTIONS,
  custodyCounterparty: CUSTODY_COUNTERPARTIES,
  custodyState: CUSTODY_STATES,
  deliveryState: DELIVERY_STATES,
  deliverySource: DELIVERY_SOURCES,
  deliveryCostKind: DELIVERY_COST_KINDS,
  deliveryCostTreatment: DELIVERY_COST_TREATMENTS,
  deliveryCostTreatmentHint: DELIVERY_COST_TREATMENTS,
  deliveryReturnDocument: DELIVERY_RETURN_DOCUMENTS,
  performanceStatus: PERFORMANCE_STATUSES,
  profitTransition: PROFIT_TRANSITIONS,
  budgetPeriodBasis: BUDGET_PERIOD_BASES,
  driverKind: DRIVER_KINDS,
  cashAdvanceState: CASH_ADVANCE_STATES,
  spendState: SPEND_STATES,
  recurrence: RECURRENCES,
  constructionContractState: CONSTRUCTION_CONTRACT_STATES,
  constructionContractKind: CONTRACT_KINDS,
  certificateState: CERTIFICATE_STATES,
  guaranteeKind: GUARANTEE_KINDS,
  guaranteeState: GUARANTEE_STATES,
  milestoneState: MILESTONE_STATES,
  progressEntryKind: PROGRESS_ENTRY_KINDS,
  assetState: ASSET_STATES,
  assetEvent: ASSET_EVENT_KINDS,
  assetCategoryState: ASSET_CATEGORY_STATES,
  depreciationRunState: DEPRECIATION_RUN_STATES,
  employmentState: EMPLOYMENT_STATES,
  leaveRequestState: LEAVE_REQUEST_STATES,
  payrollRunState: PAYROLL_RUN_STATES,
  handoverState: HANDOVER_STATES,
  appointmentKind: APPOINTMENT_KINDS,
  appointmentState: APPOINTMENT_STATES,
  defectState: DEFECT_STATES,
  defectResponsible: DEFECT_RESPONSIBLE,
  ticketKind: TICKET_KINDS,
  ticketPriority: TICKET_PRIORITIES,
  ticketState: TICKET_STATES,
  variationState: ['pendingApproval', 'approved', 'rejected'],
  notificationTitle: NOTIFICATION_TYPES,
  notificationBody: NOTIFICATION_TYPES,
  notificationState: NOTIFICATION_STATES,
  taskState: TASK_STATES,
  importState: IMPORT_STATES,
  importKind: IMPORT_KINDS,
  importRowStatus: IMPORT_ROW_STATUSES,
  taskPriority: TASK_PRIORITIES,
  customerKind: CUSTOMER_KINDS,
  identityType: IDENTITY_TYPES,
  contactChannel: CONTACT_CHANNELS,
  consentSource: CONSENT_SOURCES,
  qualificationTimeframe: QUALIFICATION_TIMEFRAMES,
  qualificationPurpose: QUALIFICATION_PURPOSES,
  decisionRole: DECISION_ROLES,
  leadAgeBand: LEAD_AGE_BANDS,
  duplicateMatch: DUPLICATE_MATCHES,
  opportunityStage: OPPORTUNITY_STAGES,
  unitEventKind: UNIT_EVENT_KINDS,
  priceVersionState: PRICE_VERSION_STATES,
  holdState: HOLD_STATES,
  planTemplateState: PLAN_TEMPLATE_STATES,
  reservationException: RESERVATION_EXCEPTIONS,
  refundHandoff: REFUND_HANDOFF_STATES,
  // Every operation a module submits for approval: one list, shared with the approval inbox.
  approvalOperation: APPROVAL_OPERATION_TYPES,
  approvalRequestState: REQUEST_STATES,
  decisionKind: DECISION_KINDS,
  instrumentEndorsement: INSTRUMENT_ENDORSEMENT_STATUSES,
  // Accounting (BMP-2 package 1)
  accountCategory: ACCOUNT_CATEGORIES,
  subledgerKind: SUBLEDGER_KINDS,
  partyKind: PARTY_KINDS,
  ledgerAccountState: LEDGER_ACCOUNT_STATES,
  entrySide: ENTRY_SIDES,
  entryState: ENTRY_STATES,
  entryKind: ENTRY_KINDS,
  journal: JOURNALS,
  fiscalYearState: FISCAL_YEAR_STATES,
  periodState: PERIOD_STATES,
  periodAction: PERIOD_ACTIONS,
  periodPending: ['open', 'reopen'],
  postingEvent: POSTING_EVENT_KEYS,
  postingEventState: POSTING_EVENT_STATES,
  postingRuleState: POSTING_RULE_STATES,
  unpostedReason: UNPOSTED_REASONS,
  // Release-1 configuration: approval policies, opening balances, posting coverage
  policyState: POLICY_STATES,
  approverKind: APPROVER_RULE_KINDS,
  approverScope: APPROVER_SCOPES,
  stageRule: STAGE_RULES,
  selfApprovalMode: SELF_APPROVAL_MODES,
  conditionField: CONDITION_FIELDS,
  conditionOperator: CONDITION_OPERATORS,
  riskLevel: RISK_LEVELS,
  openingLink: OPENING_LINK_STATUSES,
  openingTreatment: OPENING_LEDGER_TREATMENTS,
  postingEventAffects: POSTING_EVENT_KEYS,
  // Company financial statements and revenue recognition (2026-10-17)
  financialLine: [...FINANCIAL_LINES, 'unclassifiedRevenue', 'unclassifiedExpense', 'unclassified'],
  cashFlowActivity: CASH_FLOW_ACTIVITIES,
  statementKind: STATEMENT_KINDS,
  periodPreset: PERIOD_PRESETS,
  comparison: COMPARISONS,
  growthBasis: GROWTH_BASES,
  statementIssue: STATEMENT_ISSUES,
  recognitionBasis: RECOGNITION_BASES,
  recognitionDirection: RECOGNITION_DIRECTIONS,
  recognitionState: RECOGNITION_STATES,
  // Suppliers, quotations and credit notes (2026-10-17)
  awardState: AWARD_STATES,
  quoteExclusion: QUOTE_EXCLUSIONS,
  vendorPrerequisite: VENDOR_PREREQUISITES,
  vendorBlock: ['payment', 'taxInvoice', 'award', 'order'],
  vendorInvoiceKind: VENDOR_INVOICE_KINDS,
  // Receivables and invoicing (BMP-2 package 2)
  creditMovementKind: CREDIT_MOVEMENT_KINDS,
  chargeKind: CHARGE_KINDS,
  contractChangeKind: CONTRACT_CHANGE_KINDS,
  contractChangeState: CONTRACT_CHANGE_STATES,
  contractChangeBlocker: CONTRACT_CHANGE_BLOCKERS,
  customerMergeBlocker: CUSTOMER_MERGE_BLOCKERS,
  distributionMethod: DISTRIBUTION_METHODS,
  distributionRuleState: DISTRIBUTION_RULE_STATES,
  distributionSkip: DISTRIBUTION_SKIP_REASONS,
  commissionBeneficiary: COMMISSION_BENEFICIARIES,
  salesCommissionKind: SALES_COMMISSION_KINDS,
  salesCommissionState: SALES_COMMISSION_STATES,
  chargeState: CHARGE_STATES,
  waiverTarget: WAIVER_TARGETS,
  waiverState: WAIVER_STATES,
  refundSource: REFUND_SOURCES,
  refundState: REFUND_STATES,
  refundMethod: REFUND_METHODS,
  ageingBucket: AGEING_BUCKETS,
  invoiceKind: INVOICE_KINDS,
  invoiceState: INVOICE_STATES,
  penaltySource: ['configured', 'entered'],
  contractPartyRole: CONTRACT_PARTY_ROLES,
  contractException: CONTRACT_EXCEPTIONS,
  contractWarning: CONTRACT_WARNINGS,
  signingState: SIGNING_STATES,
  amendmentState: AMENDMENT_STATES,
  quotationState: QUOTATION_STATES,
  sequenceType: SEQUENCE_TYPES,
  sequenceState: SEQUENCE_STATES,
  sequenceDate: DATE_COMPONENTS,
  sequenceReset: RESET_POLICIES,
  issuedDocumentType: ISSUED_DOCUMENT_TYPES,
  issuedState: ISSUED_STATES,
  issueWarning: ISSUE_WARNINGS,
  verificationResult: VERIFICATION_RESULTS,
  // Banks, treasury and instrument custody (BMP-2 package 3)
  treasuryAccountKind: TREASURY_ACCOUNT_KINDS,
  treasuryRecordState: TREASURY_RECORD_STATES,
  movementKind: MOVEMENT_KINDS,
  movementDirection: MOVEMENT_DIRECTIONS,
  movementState: MOVEMENT_STATES,
  transferState: TRANSFER_STATES,
  paymentRequestState: PAYMENT_REQUEST_STATES,
  outgoingPaymentMethod: OUTGOING_PAYMENT_METHODS,
  outgoingChequeState: OUTGOING_CHEQUE_STATES,
  statementState: STATEMENT_STATES,
  statementLineDirection: STATEMENT_LINE_DIRECTIONS,
  matchState: MATCH_STATES,
  treasuryWarning: TREASURY_WARNINGS,
  handoverCaseState: HANDOVER_CASE_STATES,
  expenseState: EXPENSE_STATES,
  dataResetState: DATA_RESET_STATES,
  dataResetScope: DATA_RESET_SCOPES,
  templateKind: TEMPLATE_KINDS,
  revenueRecognition: REVENUE_RECOGNITION_RULES,
  projectCostSource: PROJECT_COST_SOURCES,
  templateState: TEMPLATE_STATES,
  instrumentAgeing: INSTRUMENT_AGEING_BUCKETS,
  // Users, roles and organization administration (Release-1 operational closure)
  accountState: ACCOUNT_STATES,
  completenessItem: COMPANY_COMPLETENESS_ITEMS,
  completenessNeed: COMPLETENESS_NEEDS,
  signatoryDocument: SIGNATORY_DOCUMENTS,
  readinessStatus: READINESS_STATUSES,
  readinessArea: READINESS_AREAS,
  readinessNeed: READINESS_NEEDS,
  readinessCheck: READINESS_CHECKS,
  readinessHint: READINESS_CHECKS,
  orgStatus: ORG_STATUSES,
  scopeLevel: SCOPE_LEVELS,
};

export interface EnumLabelProblem {
  locale: Locale;
  key: string;
  problem: 'missing-enum-label';
}

/** Report every displayed enum value that lacks a non-empty label in either language. */
export function checkEnumLabels(
  all: Record<Locale, Record<string, ResourceTree>>,
  enums: Readonly<Record<string, readonly string[]>> = DISPLAYED_ENUMS,
  namespace = 'common',
): EnumLabelProblem[] {
  const problems: EnumLabelProblem[] = [];
  for (const locale of SUPPORTED_LOCALES) {
    const tree = all[locale][namespace] ?? {};
    for (const [group, values] of Object.entries(enums)) {
      for (const value of values) {
        // A dotted value (`approval.pending`) is stored nested, because i18next reads `.` as a
        // key separator; follow the path exactly as the runtime lookup will.
        let label: string | ResourceTree | undefined = tree[group];
        for (const part of value.split('.')) {
          label = typeof label === 'object' ? label[part] : undefined;
        }
        if (typeof label !== 'string' || label.trim() === '') {
          problems.push({ locale, key: `${group}.${value}`, problem: 'missing-enum-label' });
        }
      }
    }
  }
  return problems;
}
